<template>
  <div class="container" v-if="result.total.hasOwnProperty('fasteners')">
    <div class="row">
      <div class="common__title-result">
        Крепежный элемент
      </div>
      <div class="common__result-info">
        <img src="@/assets/img/result-info.svg" alt="i">
        Подробная информация по крепежному элементу для каждого
        участка рассчитана на странице участка
      </div>
      <div class="fastener">
        <div class="fastener__head">
          <div class="fastener__head-title">Наименование</div>
          <div class="fastener__head-title">К-во</div>
        </div>
        <div class="fastener__item" v-for="(item, i) in filteredFasteners" :key="i">
          <div class="fastener__item-img"><img :src="item.src"
                                               :alt="item.name"></div>
          <div class="fastener__item-title">{{ item.name }}</div>
          <div class="fastener__item-count">{{ item.count }} шт.</div>
        </div>
        <div class="fastener__footer"
             v-if="fullCurrentFastenersArray.length > 18"
             @click="isShowRemaining = !isShowRemaining"
             :class="{ 'fastener__footer-active': isShowRemaining }">
          <div v-if="!isShowRemaining" class="fastener__footer-count">
            Показать все: {{ fullCurrentFastenersArray.length }}
          </div>
          <div v-else class="fastener__footer-count">Скрыть</div>
          <div class="fastener__footer-arrow">
            <img src="@/assets/img/showMore.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  props: {
    resultFasteners: Array,
  },
  data() {
    return {
      isShowRemaining: false,
    };
  },
  components: {
  },
  methods: {
    findFastener(id) {
      return this.fasteners[this.fasteners.findIndex(p => p.id === id)];
    },
    getFullCurrentFastenersArray() {
      const fullCurrentFastenersArray = [];
      for (let i = 0; i < this.resultFasteners.length; i += 1) {
        fullCurrentFastenersArray.push(this.resultFasteners[i]);
        fullCurrentFastenersArray[i].name = this.findFastener(fullCurrentFastenersArray[i].id).name;
        fullCurrentFastenersArray[i].src = this.findFastener(fullCurrentFastenersArray[i].id).src;
      }
      return fullCurrentFastenersArray;
    },
  },
  mounted() {
  },
  computed: {
    ...mapState({
      fasteners: state => state.fasteners,
      result: state => state.result,
    }),
    sortedFasteners() {
      const cloned = cloneDeep(this.fullCurrentFastenersArray);
      return cloned.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        let comparison = 0;
        if (nameA < nameB) {
          comparison = -1;
        } else if (nameA > nameB) {
          comparison = 1;
        }
        return comparison;
      });
    },
    filteredFasteners() {
      return this.isShowRemaining ? this.sortedFasteners : this.sortedFasteners.slice(0, 18);
    },
    fullCurrentFastenersArray() {
      return this.getFullCurrentFastenersArray();
    },
  },
};
</script>
<style lang="sass" scoped>
  .fastener
    width: 100%
    color: $black
    text-align: left
    &__head
      display: grid
      background: #F6F6F6
      border: rem(1) solid #ECECEC
      box-sizing: border-box
      border-radius: rem(4) rem(4) 0 0
      +media((padding: (320: rem(16) rem(24), 992: rem(25) rem(40))))
      +media((grid-template-columns: (320: 4fr 7fr 3fr, 576: 4fr 8fr 4fr, 768: 3fr 17fr 2fr)))
      &-title
        font-style: normal
        font-weight: bold
        font-size: rem(14)
        line-height: rem(18)
        color: $black
        &:first-of-type
            grid-column-start: 2
    &__item
      display: grid
      +media((grid-template-columns: (320: 4fr 7fr 3fr, 576: 4fr 8fr 4fr, 768: 3fr 17fr 2fr)))
      background: #fff
      margin-bottom: rem(1)
      min-height: rem(40)
      +media((padding: (320: 0 rem(24), 992: 0 rem(40))))
      &-title, &-count
        font-style: normal
        font-weight: 500
        font-size: rem(14)
        display: flex
        flex-direction: row
        align-items: center
        +media((line-height: (320: rem(20), 992: rem(30))))
      &-img
        display: flex
        flex-direction: column
        justify-content: center
        align-items: flex-start
        img
          max-width: rem(69)
          max-height: rem(40)
          object-fit: cover
    &__footer
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      cursor: pointer
      background: #F6F6F6
      border: rem(1) solid #ECECEC
      box-sizing: border-box
      border-radius: rem(4)
      padding: rem(25) rem(40)
      &-count
        font-style: normal
        font-weight: 600
        font-size: rem(14)
        line-height: rem(17)
        color: $red
      &-arrow
        img
          transition: .5s
      &-active
        .fastener__footer-arrow
          img
            transform: rotate(180deg)
</style>
